export default class extends Controller {
  static targets = ["placeholder"];
  connect() {
    App.Helpers.listenToCustomEvent(document, "filter-triggered", this.filterByStatus.bind(this));
  }

  filterByStatus(event) {
    const {el, value} = event.detail;
    if (this.element.contains(el)) {
      this.placeholderTarget.innerHTML = App.spinner();
      App.Helpers.ajaxRequest({
        url:            this.newURLFor(value),
        successHandler: this.replaceListWith.bind(this)
      });
    }
  }

  replaceListWith(res) {
    App.Helpers.replaceElement(this.element, res);
  }

  newURLFor(status) {
    return App.Helpers.addParamsToURL(this.url, {status});
  }

  //
  // GETTERS AND SETTERS
  //

  get url() {
    return this.data.get('url');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/filtering/status-filter-controller.js